import Button from '@mui/material/Button';
import React, { useState } from 'react';

import { CustomTableAdditionalButtonProps } from '@/components/table/components/formBuilder/model/CustomTableAdditionalButtons.model.ts';
import { TimelineMessagesTableParams } from '@/components/timelineMessages/comp/confirmMessagesReadButton/model/TimelineMessagesTableParams.model.ts';
import { useMarkResourceMessagesAsRead } from '@/components/timelineMessages/comp/confirmMessagesReadButton/util/useMarkResourceMessagesAsRead.util.ts';
import { CommonDialog } from '@/components/ui/deleteDialog/CommonDialog.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { TasksListSearchFormModel } from '@/views/tasks/list/model/TasksListSearchForm.model.ts';

type Props = CustomTableAdditionalButtonProps<
  TasksListSearchFormModel,
  TimelineMessagesTableParams
>;

export const TimelineMessagesConfirmMessagesReadButton: React.FC<Props> = props => {
  const { isLoading, params } = props;
  const resource = params?.resource;
  const { isMarking, markResourceMessagesAsSeen } = useMarkResourceMessagesAsRead();
  const { t } = useTranslationWithPrefix('views.processesDetails.tasks');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!resource) {
    throw new Error('resource is not defined');
  }

  const handleConfirm = async () => {
    await markResourceMessagesAsSeen({
      resource: { resourceId: resource.resourceId, type: resource.type },
    });
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <Button
        disabled={isLoading}
        loading={isMarking || isLoading}
        onClick={handleOpenDialog}
        variant="outlined"
      >
        {t('button.markMessagesAsSeen')}
      </Button>
      {isDialogOpen && (
        <CommonDialog
          cancelButtonLabel={t('dialog.markMessagesAsSeen.button.cancel')}
          confirmButtonLabel={t('dialog.markMessagesAsSeen.button.confirm')}
          content={t('dialog.markMessagesAsSeen.content')}
          onCancel={handleCloseDialog}
          onConfirm={handleConfirm}
          title={t('dialog.markMessagesAsSeen.title')}
        />
      )}
    </>
  );
};
